import rules from "../../rules";
import { checkPermission } from "../../rules";

const check = (role, action, data, permissions) => {
	// If permissions array is provided (from backend), use dynamic check
	if (permissions && Array.isArray(permissions)) {
		return checkPermission(permissions, action);
	}

	// Fallback to static rules
	const ruleSet = rules[role];
	if (!ruleSet) {
		return false;
	}

	const staticPermissions = ruleSet.static;

	if (staticPermissions && staticPermissions.includes(action)) {
		return true;
	}

	const dynamicPermissions = ruleSet.dynamic;

	if (dynamicPermissions) {
		const permissionCondition = dynamicPermissions[action];
		if (!permissionCondition) {
			return false;
		}

		return permissionCondition(data);
	}
	return false;
};

const Can = ({ role, perform, data, yes, no, permissions }) =>
	check(role, perform, data, permissions) ? yes() : no();

Can.defaultProps = {
	yes: () => null,
	no: () => null,
};

export { Can };
